const shouldShowHelpButtons = import.meta.env.VITE_SHOW_HELP_BUTTONS === 'true'

export default shouldShowHelpButtons
